import store from '../store';
import { saveSalesChannelName } from '../actions/sales_channel_actions';

export const setSalesChannelName = (urlAddress) => {
  const searchParams = (new URL(urlAddress)).searchParams;
  const name = searchParams.get('salesChannel');
  if (name) {
    store.dispatch(saveSalesChannelName(name));
  }
};


// WEBPACK FOOTER //
// ./src/services/sales_channel.js